/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./participateList.vue?vue&type=template&id=afb4837e&scoped=true&"
import script from "./participateList.vue?vue&type=script&lang=js&"
export * from "./participateList.vue?vue&type=script&lang=js&"
import style0 from "./participateList.vue?vue&type=style&index=0&id=afb4837e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb4837e",
  null
  
)

export default component.exports